import { Outlet } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import { Header } from './components/Header';

function App() {
  return (
    <div className="flex flex-col min-h-screen max-w-screen overflow-hidden">
      <Header />
      <div className="grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default App;
